import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import SearchResultEntity from "../../../../domain/entities/search_result.entity";
import HumanAgentEntity, { HumanAgentStatus } from "../../../../domain/entities/human_agent.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import HumanAgentDto from "../../../dto/human_agent.dto";

const searchHumanAgentsApiImpl = async (_: { query?: string, status?: HumanAgentStatus, page: number, itemsPerPage: number, operationId?: string }): Promise<Either<ErrorEntity, SearchResultEntity<HumanAgentEntity>>> => {
    try {
        let relativeUrl: string = `/human-agent/search?page_number=${_.page}&page_size=${_.itemsPerPage}&name=${_.query ?? ""}`;
        console.log("status", _.status);
        if(_.operationId && _.operationId != "") relativeUrl += `&operation_id=${_.operationId}`;
        if (_.status != null) relativeUrl += `&status=${_.status == HumanAgentStatus.active ? "true" : "false"}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = response.content.map((item: any) => HumanAgentDto.fromJSON(item));
        return right({
            data: parsed,
            itemsPerPage: _.itemsPerPage,
            page: _.page,
            pages: response.total_pages,
            total: response.total_elements
        })
    } catch (e) {
        console.log("searchhumanagentsapiimpl error", e);
        return left({ code: "Error" });
    }
};

export default searchHumanAgentsApiImpl;